import React, { useEffect, useRef, useState } from "react";
import SMSMagicSvg from "../../assets/svg/SMS-Magic.svg";
import SalesforceImg from "../../assets/svg/Salesforce_logo_img.svg.png";
import Hand from "../../assets/svg/Hand.svg";
import {  IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import LatestRight from "../../assets/svg/LatestRight.svg";
import { WORKSPACE_REDIRECT_TIMEOUT } from "../../constants/common";

const DataCenterUpdate = ({ state, callPackageInfoAPI, isContinueLoading, isUpgradeLoading }) => {
  const [countdown, setCountdown] = useState(null);
  const intervalIdRef = useRef(null);
  //   let state = {
  //     dataCenter: "US",
  //     addons: {
  //       type: "upgrade",
  //       package_installed: false,
  //       account_exists: true,
  //       latest_version: "1.73",
  //       upgrade_available: true,
  //       package_version: "1.72.22",
  //     },
  //   };
// eslint-disable-next-line no-unused-vars
  const [country, setCountry] = useState(
    state?.dataCenter == "US" // eslint-disable-line eqeqeq
      ? "US"
      : state?.dataCenter == "EU" // eslint-disable-line eqeqeq
      ? "Europe"
      : "Australia"
  );

  const initiateProcess = () => {
    startTimer();
    // callPackageInfoAPI();
  };

  const startTimer = async () => {
    setCountdown(WORKSPACE_REDIRECT_TIMEOUT);
    intervalIdRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(intervalIdRef.current);
          callPackageInfoAPI("continueWorkspace");
          //   window.location.replace(
          //     `${process.env.REACT_APP_LANDING_PAGE_BASE_URL}workspace`
          //   );
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

/* eslint-disable react-hooks/exhaustive-deps */
useEffect(() => {
  if (state?.addons?.upgrade_available === false && state?.addons?.package_installed) {
    initiateProcess();
  }

  return () => {
    clearInterval(intervalIdRef.current);
  };
}, []);
/* eslint-enable react-hooks/exhaustive-deps */

  const handleUpdate = async (type) => {
    console.log("in handleUpdate", type);

    if (type == "continue") { // eslint-disable-line eqeqeq
      console.log("calling package info api");
      await callPackageInfoAPI("continueWorkspace");
    } else {
      await callPackageInfoAPI("upgrade");
    }
  };

  return (
    <div className="installation-container">
      <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>
      <main className="main-content" style={{ maxWidth: "44rem" }}>
        <div className="icon-container">
          <img
            src={SMSMagicSvg}
            alt="SMS-Magic Icon"
            className="icon"
            style={{ width: "180px", height: "131.5px" }}
          />
          <div
            className="dotted-line"
            style={
              state?.addons?.upgrade_available == false // eslint-disable-line eqeqeq
                ? { borderTop: "2px dotted #408B56" }
                : {}
            }
          />
          {/* <div>
            <img src={Hand} alt={"hand"} className={"hand"} />
          </div> */}
          <div>
            <img
              src={
                state?.addons?.upgrade_available == true ? Hand : LatestRight // eslint-disable-line eqeqeq
              }
              alt={"hand"}
              className={"hand"}
            />
          </div>
          <div
            className="dotted-line"
            style={
              state?.addons?.upgrade_available == false // eslint-disable-line eqeqeq
                ? { borderTop: "2px dotted #408B56" }
                : {}
            }
          />
          <div className="salesforce-logo-container">
            <img
              src={SalesforceImg}
              alt="Salesforce Logo"
              className="salesforce-logo"
              style={{ width: "180px", height: "126.75px" }}
            />
          </div>
        </div>


        {/* <div className=""> */}
        <div className="info-box-cancel" style={{ marginBottom: "10px" }}>
          <IconButton style={{ padding: "0px" }}>
            <InfoIcon style={{ padding: "0px", color: "#AEB0B1" }} />
          </IconButton>

          <span className="info-text">
            You have an account on the {country} Data Center
          </span>
        </div>
        {state?.addons?.upgrade_available &&
        state?.addons?.package_installed ? (
          <div className="installation-text" style={{ margin: "0px" }}>
            <h1 className="title">Upgrade your SMS Magic Account on </h1>
            <h2 className="subtitle">
              {" "}
              {country} Data Center from {state?.addons?.package_version} to
              latest version {state?.addons?.latest_version}
            </h2>
          </div>
        ) : state?.addons?.upgrade_available == false && // eslint-disable-line eqeqeq
          state?.addons?.package_installed ? (
          <div className="installation-text" style={{ margin: "0px" }}>
            <h1 className="title">
              Your account on the {country} Data Center is Already{" "}
            </h1>
            <h2 className="subtitle">
              {" "}
              on the Latest Version {state?.addons?.package_version} of SMS
              Magic
            </h2>
          </div>
        ) : (
          <div className="installation-text" style={{ margin: "0px" }}>
            <h1 className="title">
              No packages found on your US Data Center Account.
            </h1>
            <h2 className="subtitle"> Installing the latest ones now</h2>
          </div>
        )}

        {state?.addons?.upgrade_available &&
        state?.addons?.package_installed ? (
          <p className="subtitle-magic" style={{ textAlign: "center" }}>
            Upgrade to latest version for enhanced support and improved
            efficiency. <br />
            View the,{" "}
            <a
              href={process.env.REACT_APP_RELEASE_NOTES}
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              release notes
            </a>{" "}
            to compare updates.
          </p>
        ) : state?.addons?.upgrade_available == false &&  // eslint-disable-line eqeqeq
          state?.addons?.package_installed ? (
          <p className="subtitle-magic" style={{ textAlign: "center" }}>
            You already have the latest SMS Magic package installed.Continue to
            start using it.
          </p>
        ) : (
          <p className="subtitle-magic" style={{ textAlign: "center" }}>
            Your SMS Magic package is being installed and configured now.
          </p>
        )}

        {state?.addons?.upgrade_available &&
        state?.addons?.package_installed ? (
          <>
            <button
              className="install-packages"
              style={{
                fontSize: "14px",
                color: "white",
                padding: "0px 15px",
                width: "250px",
                display: "flex",
                alignItems: "center",
                gap: "0px",
                justifyContent: "space-evenly"
              }}
              onClick={() => handleUpdate("upgrade")}
            >
              Upgrade to latest version
              {isUpgradeLoading && 
                <div className="" style={{marginTop: "2px"}}>
                  <div className="spinner-border" role="status" style={{width: "20px", height: "20px"}}/>
                </div>
              }
            </button>
            <span
              onClick={() => handleUpdate("continue")}
              className={"cancel-link-text"}
              style={{ marginTop: "12px", textDecoration: "none", display: "flex", alignItems: "center", gap: "8px" }}
            >
              Continue without upgrade
              {isContinueLoading && 
                <div className="">
                  <div className="spinner-border" role="status" style={{width: "20px", height: "20px"}}/>
                </div>}
            </span>
          </>
        ) : (
          <>
            {/* <div
              className="cancel-link"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              Do you want to cancel installation?{" "}
              <a
                href="#"
                // onClick={handleCancel}
                className={"cancel-link-text"}
                // className={
                //   cancelShow ? "cancel-link-text" : "cancel-link-text-disabled"
                // }
              >
                Cancel
              </a>
            </div> */}
            <div className="workspace-redirect">
              Redirecting to workspace in{" "}
              <span className="timer">{countdown} seconds</span>
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default DataCenterUpdate;
